<div class="p-[24px] h-fit">
  <div class="flex fl-al-center gap-[12px]">
    <div class="h-[38px] w-[38px] flex-center bg-[#25508E] rounded-[4px]"><img class="h-[24px] w-[24px]"
    src="assets/images/info-outline-white.svg" /></div>
    <div class="font-bold text-base  font-open-sans text-[#18191C]">
      @if (data.isActive) {
        <Span>Activate Template?</Span>
      }
      @if (!data.isActive) {
        <span>Deactivate Template?</span>
      }
    </div>
  </div>

  <div class="mt-[20px] text-sm font-medium  font-open-sans text-[#18191C]">
    @if (data.isActive) {
      <span>
        All applicable data from this template will no longer be excluded from all reports and checklists. Are you
        sure you want to continue?
      </span>
    }
    @if (!data.isActive) {
      <span>
        All applicable data from this template will be excluded from Assets & Liabilities Report, Ownership Map, and Checklists. Are you sure you want to continue?
      </span>
    }
  </div>

  @if (!data.isActive) {
    <div class="mt-[12px]">
      <mat-form-field appearance="fill"
        class="expiration-form automtic-form-desing-form-only app__medium--height--form deactiveDate-form w-full">
        <mat-label class="automtic-form-desing-lable">Effective Deactivation Date </mat-label>
        <!-- <input matInput [matDatepicker]="dp7" style="display: none" readonly (click)="dp7.open()" name="deactiveDate" (dateChange)="setDate($event.value)" [(ngModel)]="deactivedate"/> -->
        <input
          matInput
          [value]="connectionForm.controls['deactiveDate']"
          formControlName="deactiveDate"
          style="display: none"
          />
          <input
            matInput
            [matDatepicker]="dp7"
            (dateChange)="setDate($event.value)"
            style="display: none"
            [max]="today"
            />
            {{ connectionForm.controls['deactiveDate'].value ? moment(connectionForm.controls['deactiveDate'].value).format('MMM DD, YYYY') : '' }}
            <mat-datepicker-toggle matSuffix [for]="dp7"></mat-datepicker-toggle>
            <mat-datepicker #dp7 disabled="false"></mat-datepicker>
          </mat-form-field>
        </div>
      }

      <div class="flex gap-[12px] mt-[8px]" style="justify-content: end;">
        <button (click)="cancel()"
        class="bg-[#FFF] py-[6px] px-[20px] h-[36px] w-fit text-[##18191C]  font-open-sans text-xs font-bold rounded-[4px] border-[#18191C] border  flex-center">Cancel</button>
        <button
          class="bg-[#25508E] py-[6px] px-[20px] h-[36px] w-fit text-[#FFF]  font-open-sans text-xs font-bold rounded-[4px] border-[#25508E] border flex-center"
          (click)="confirm()">
          @if (data.isActive) {
            <span>Activate</span>
          }
          @if (!data.isActive) {
            <span>Deactivate</span>
          }
        </button>
      </div>
    </div>